<template>
  <div class="embed embed--html" :title="caption">
    <div class="embed__content" v-html="content" />
    <div v-if="caption" class="embed__caption">{{ caption }}</div>
  </div>
</template>

<script>
export default {
  name: 'PostContentEmbedHtml',
  props: {
    content: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="postcss" scoped>
@import './styles.css';
</style>
